var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingUpFilled = function SvgTrendingUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 6a1 1 0 1 0 0 2h4.586l-6.162 6.162c-.21.21-.325.323-.414.4l-.01.008-.01-.009a8 8 0 0 1-.414-.4l-2.76-2.76a9 9 0 0 0-.512-.487 2 2 0 0 0-.686-.402 2 2 0 0 0-1.236 0c-.29.094-.512.254-.686.402-.16.135-.333.31-.512.488l-4.891 4.89a1 1 0 1 0 1.414 1.415l4.869-4.869c.21-.21.325-.323.414-.4L8 12.43l.01.009c.09.076.205.19.414.4l2.76 2.76c.179.178.352.352.511.487.175.148.397.308.687.402a2 2 0 0 0 1.236 0c.29-.094.512-.254.687-.402a9 9 0 0 0 .51-.488L21 9.414V14a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1z"
  })));
};
export default SvgTrendingUpFilled;